import { Component, OnInit, ViewChild , Output, EventEmitter} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import { MatStepper } from '@angular/material/stepper'

export interface tabledata {
  repaginate: boolean;
  status: string;
  sequence: number;
  formid: string;
  formtitle: string;  
  description?: string;
  instructions? : string;
  editable: string;
}

const data: tabledata [] = [
  {
    repaginate: true,
    status : "To Be Generated",
    sequence: 1,
    formid: 'NA- Cover Page',
    formtitle: 'Cover Page NA',
    description: '',
    instructions : '',
    editable: 'N',
  },
  {
    repaginate: true,
    status : "To Be Generated",
    sequence: 2,
    formid: 'US-FAC-REINSURANCE-CERTIFICATE-EN',
    formtitle: 'Facultative Reinsurance Certificate',
    description: '',
    instructions : '',
    editable: 'Y',
  },
  {
    repaginate: true,
    status : "To Be Generated",
    sequence: 3,
    formid: 'WW-FAC-REINSURANCE-CERTIFICATE-US-CAN-EN',
    formtitle: 'Facultative Reinsurance Certificate(US-CAN)',
    description: '',
    instructions : '',
    editable: 'N',
  }
];

@Component({
  selector: 'cmpts-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.css']
})
export class DatatableComponent implements OnInit {
  columns : string[] = ['select','repaginate','status','sequence','formid','formtitle','description','instructions','editable'];
  dataSource = new MatTableDataSource<tabledata>(data);    
  selection = new SelectionModel<tabledata>(true, []);
  isShow = true;  
  @Output() onclick = new EventEmitter<any>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor() { }

  ngOnInit(): void {        
    this.dataSource.sort = this.sort;      
    this.dataSource.paginator= this.paginator;
  }

  ngAfterViewInit (){
    this.dataSource.sort = this.sort;   
    this.dataSource.paginator= this.paginator;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;     
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if(this.isAllSelected())
    {
      this.selection.clear() ;
      this.isShow = false;
      this.toggleDisplay();
      console.log(this.isShow+ " in if function");
    }
    else
    {  
      this.dataSource.data.forEach(row => this.selection.select(row));
      this.isShow = true;
      this.toggleDisplay();      
      console.log(this.isShow+ " in else function");
    }
  }

  toggleDisplay() {
    this.isShow = !this.isShow;
  }

  CheckBoxChanged(model: any) {
    const numSelected = this.selection.selected.length;   

    if (model.checked == true) {      
      this.isShow = true;
    } else {
        this.isShow = false;
    }
    this.toggleDisplay();   
  }

  onClickButton(event) {
    /*setTimeout(() => {   
      console.log(this.myStepper);        
      //this.myStepper.next();
     }, 5000);
    
    event.preventDefault();*/
    this.onclick.emit(event);
  }
}
